export type QuickTipsTranslation = {
  feedbackTip: string;
  quickTips: string;
  redFlagsTip: string;
  strengthsTip: string;
  weaknessesTip: string;
};

export const quickTipsTranslation: QuickTipsTranslation = {
  feedbackTip:
    ' After analyzing the CV, provide constructive feedback. Highlight strengths, address\n' +
    'weaknesses, and mention any concerns. This can help candidates improve their future applications and\n' +
    'guide hiring decisions.',
  quickTips: 'Quick Tips',
  redFlagsTip:
    'Be aware of warning signs in the CV, such as frequent job changes, unexplained gaps, or\n' +
    'inconsistencies in information. These may indicate potential issues that require further investigation.\n',
  strengthsTip:
    "Look for the candidate's positive attributes, such as relevant skills, accomplishments, and\n" +
    'experience that align with the job requirements. These indicate their potential to succeed in the role.\n',
  weaknessesTip:
    'Identify areas where the candidate may lack necessary skills or experience. This could\n' +
    'include gaps in employment or insufficient qualifications. Understanding weaknesses can help assess\n' +
    'their fit for the position.',
};
